/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Price_Expert_ReportInputs */

const cs_sreality_attr_price_expert_report = /** @type {(inputs: Sreality_Attr_Price_Expert_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena dle znaleckého posudku`)
};

const en_sreality_attr_price_expert_report = /** @type {(inputs: Sreality_Attr_Price_Expert_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expert appraisal price`)
};

/**
* | output |
* | --- |
* | "Expert appraisal price" |
*
* @param {Sreality_Attr_Price_Expert_ReportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_price_expert_report = /** @type {((inputs?: Sreality_Attr_Price_Expert_ReportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Price_Expert_ReportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_price_expert_report(inputs)
	return cs_sreality_attr_price_expert_report(inputs)
});